import client from './api-client'

export const postCargarArchivo = async (file) => {
  try {
    const response = await client.post('emision-pagos-cia/carga-archivo', file)

    if (response.status === 200 && response.data.code === 1) {
      return response.data.message
    } else {
      throw new Error(response.data.message)
    }
  } catch (error) {
    throw error
  }
}

export const serviceGetInformeAnalytic = async () => {
  try {
    const response = await client.get(`analytic2/carga-archivo`)
    if (response.status === 200 && response.data.code === 1) {
      return response.data
    } else {
      throw new Error(response.data.message)
    }
  } catch (error) {
    throw error
  }
}

export const getInfoErroresCargaAnalytic = async (query) => {
  try {
    const response = await client.get(`analytic2/carga-errores?q=${query}`)
    if (response.status === 200 && response.data.code === 1) {      
      return response.data.object;      
    } else {
      throw new Error(response.data.message)
    }
  } catch (error) {
    throw error
  }
}
